import type { FunctionComponent, SVGProps } from 'react'

import type { ProductImageKind } from '../../models/productImage'

import { ReactComponent as Accessory } from './assets/accessory.svg'
import { ReactComponent as Desktop } from './assets/desktop.svg'
import { ReactComponent as Display } from './assets/display.svg'
import { ReactComponent as Generic } from './assets/generic.svg'
import { ReactComponent as Headset } from './assets/headset.svg'
import { ReactComponent as Laptop } from './assets/laptop.svg'
import { ReactComponent as Printer } from './assets/printer.svg'
import { ReactComponent as PrinterMfp } from './assets/printerMfp.svg'
import { ReactComponent as Promotion } from './assets/promotion.svg'

/**
 * The stand-in drawing for each product kind, inlined as components so they cost
 * no request and stay crisp at the two sizes the list uses (102x81 in a card,
 * full width in the end-customer promo panel).
 *
 * They share one construction, following Veneer's lined iconography: a `#F4F5F7`
 * plate at the `shape = 8` radius, 2px `#737373` outlines with round joins,
 * `#E1F1FA` for screens and paper, and a single `#0096D6` accent per drawing.
 * Keep any new kind on those rules — the set has to read as one family when
 * several land in the same list.
 */
export const PRODUCT_IMAGE_FALLBACKS: Readonly<
  Record<ProductImageKind, FunctionComponent<SVGProps<SVGSVGElement>>>
> = {
  laptop: Laptop,
  desktop: Desktop,
  display: Display,
  printer: Printer,
  printerMfp: PrinterMfp,
  headset: Headset,
  accessory: Accessory,
  promotion: Promotion,
  generic: Generic,
}
